import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../../service/api';
import styles from './index.module.css';
import NavbarComponent from '../../components/Navbar/NavbarComponent';
import NavMenuComponent from '../../components/NavMenu/NavMenuComponent';
import { Row, Col, Button } from "reactstrap";
import { MdOutlineModeEditOutline } from "react-icons/md";

function VisualizarEmpresa() {
    const { id } = useParams();
    const [empresa, setEmpresa] = useState([]);

    useEffect(() => {
        api.get('empresa/' + id).then(({ data }) => {
            setEmpresa(data);
        });
    }, [id]);

    return (
        <div className={styles.mainDiv}>
            <NavbarComponent />
            <NavMenuComponent />

            <div className={styles.route}>
                <Link to="/home" className={styles.link}> Home </Link> &gt;
                <Link to="/empresas" className={styles.link}> Lista de Empresas </Link> &gt;
                <span> Empresa </span>
            </div>

            <div className={styles.title}>
                Perfil da Empresa
            </div>

            <div className={styles.divButton}>
                <Link to={`/editarEmpresa/${empresa.id}`}>
                    <Button size="sm" className={styles.buttonEditar}>
                        <MdOutlineModeEditOutline size={17} className={styles.buttonIcon} />Editar
                    </Button>
                </Link>
            </div>

            <div responsive className={styles.container}>
                <div className={styles.divDadosParceiros}>
                    Dados da Empresa
                </div>

                <div className={styles.linha} />

                <div className={styles.divInfoParceiro}>
                    <Row xs="4">
                        <Col>
                            Nome Fantasia <p className={styles.p}>{empresa.nome_fantasia}</p>
                        </Col>

                        <Col>
                            Razão Social <p className={styles.p}>{empresa.razao_social}</p>
                        </Col>

                        <Col>
                            CNPJ <p className={styles.p}>{empresa.cnpj}</p>
                        </Col>

                        <Col>
                            CEP <p className={styles.p}>{empresa.cep}</p>
                        </Col>

                        <Col>
                            Rua, Número <p className={styles.p}>{`${empresa.rua}, ${empresa.numero}`}</p>
                        </Col>

                        <Col>
                            Bairro <p className={styles.p}>{empresa.bairro}</p>
                        </Col>

                        <Col>
                            Cidade - UF <p className={styles.p}>{`${empresa.cidade} - ${empresa.estado}`}</p>
                        </Col>

                        <Col>
                            País <p className={styles.p}>{empresa.pais}</p>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default VisualizarEmpresa;
